"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "marmirolo": {
    "f350f3bf": [{
      "hkey": "500a4e01",
      "slug": "pozzolo-sul-mincio",
      "name": "Pozzolo sul Mincio",
      "primary": true,
      "skipSearch": false
    }],
    "pozzolo": [{
      "hkey": "500a4e01",
      "slug": "pozzolo-sul-mincio",
      "name": "Pozzolo sul Mincio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8de800da": [{
      "hkey": "2f38bc15",
      "slug": "marmirolo",
      "name": "Marmirolo",
      "primary": true,
      "skipSearch": false
    }],
    "campagnazza": [{
      "hkey": "2f38bc15",
      "slug": "marmirolo",
      "name": "Marmirolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;